export const ROW_LAYOUT = ['grid-1', 'grid-1', 'grid-2', 'grid-2', 'grid-2', 'grid-2', 'grid-1', '40px'] as const;
export const ROW_HEIGHT = '50px';
